import { computeCorrectScore, findMatches } from "./helper";
import { urlScoreWeights, urlSlugLengthCheck } from "./urlSlugHelper";

// Target Keyword Check
const targetKeywordAnalysis = (formikProps) => {
  if (formikProps.values.url_slug.trim().length == 0) {
    return -1;
  }
  const seoRequest = formikProps.values.seo_request;
  const urlSlug = formikProps.values.url_slug
    .split(/(?:[-._])|(\d+)/)
    .filter(Boolean);
  let count = 0;
  urlSlug.forEach((item) => {
    const matches = findMatches(seoRequest, item);

    if (matches) {
      count += 1;
    }
  });
  if (count == 0) {
    return 0;
  } else {
    return (count / seoRequest.split(/(?:[-._\s]|\d+)/).length) * 100;
  }
};

// Url Length Check
const urlSlugLength = (formikProps) => {
  const urlSlugWords = formikProps.values.url_slug
    .split(/(?:[-._])|(\d+)/)
    .filter(Boolean);
  if (
    formikProps.values.url_slug.trim().length == 0 ||
    formikProps.values.url_path.trim().length == 0
  ) {
    return {
      score: -1,
      completeUrlLength: 0,
      urlSlugLength: 0,
      text: "",
    };
  }
  const completeUrl = formikProps.values.url_path
    .trim()
    .replace(/(^\w+:|^)\/\//, "")
    .concat(formikProps.values.url_slug);

  return urlSlugLengthCheck(completeUrl.length, urlSlugWords.length);
};

// Url Depth Check
const urlDepth = (formikProps) => {
  // Vérification de la validité de l'URL
  if (
    formikProps.values.url_slug.trim().length == 0 ||
    formikProps.values.url_path.trim().length == 0
  ) {
    return { score: -1, value: 0 }; // Si l'URL est vide, retourne un score invalide
  }

  const completeUrl = formikProps.values.url_path
    .trim()
    .replace(/(^\w+:|^)\/\//, ""); // Supprimer le protocole (http:// ou https://)

  // Calcul de la profondeur de l'URL en fonction des "/"
  let without_domain = completeUrl.split("/").filter((x) => x.trim() !== "");
  without_domain.shift(); // Enlever le domaine pour ne garder que la structure de l'URL

  let depth = without_domain.length;
  let score = 0;

  // Si la profondeur est trop grande, on pénalise lourdement
  if (depth > 4) {
    score = 0; // Trop profond, on pénalise fortement
  }
  // Si la profondeur est de 4, on applique une pénalité légère
  else if (depth === 4) {
    score = 50;
  }
  // Si la profondeur est optimale (3 ou moins), on attribue un score maximal
  else if (depth <= 3) {
    score = 100;
  }

  return { score: score, value: depth };
};

// LowerCaseCheck
const lowerCaseCheck = (formikProps) => {
  const slug = formikProps.values.url_slug.trim();
  if (slug.length == 0) {
    return { score: -1, letterLength: 0 };
  }
  const letters = slug.match(/[A-Z]/g)?.join("");
  if (letters && letters.length > 0) {
    return { score: 0, letterLength: letters.length };
  } else {
    return { score: 100, letterLength: 0 };
  }
};

// Special Character and Seperator Check
const seperatorCheck = (formikProps) => {
  const slug = formikProps.values.url_slug.trim();
  if (slug.length == 0) {
    return -1;
  }
  var format = /[!@#$%^&*()_ +=\[\]{};':"\\|,.<>\/?]+/;
  const dateRegex =
    /(\b\d{1,2}[\/\-]\d{1,2}[\/\-]\d{2,4}\b)|(\b\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}\b)|(\b(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]* \d{1,2},? \d{4}\b)|(\b\d{1,2} (?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)[a-z]*,? \d{4}\b)|(\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z\b)|(\b\d{10}\b)/i;
  const numberRegex = /\d+/g;
  if (format.test(slug) || dateRegex.test(slug) || numberRegex.test(slug)) {
    return 0;
  } else {
    return 100;
  }
};

// Score Calculation
export const startURLAnalysis = (formikProps) => {
  const targetKeywordScore = targetKeywordAnalysis(formikProps);

  const urlLength = urlSlugLength(formikProps);
  const depth = urlDepth(formikProps);
  const lowerCase = lowerCaseCheck(formikProps);
  const seperator = seperatorCheck(formikProps);
  let totalScore = computeCorrectScore(
    [
      targetKeywordScore,
      urlLength.score,
      depth.score,
      lowerCase.score,
      seperator,
    ],
    urlScoreWeights
  );

  return {
    keyword_score: targetKeywordScore,
    url_length: urlLength,
    url_depth: depth,
    lowerCase_check: lowerCase,
    seperator_check: seperator,
    total_score: Math.round(totalScore),
  };
};
